import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import { formatDateFromISO } from 'common/utils/format.utils';
import { RenderDrawerComponent } from '../components/render-drawer.component';
import { EAuditColumnKeys } from '../enums/audit.enums';
import { TAuditTableRecord } from '../types/audit.types';

export const getColumns = (): ColumnsType<TAuditTableRecord> => [
  {
    title: <Trans i18nKey="reporting.audit.table.column.id.title" />,
    width: 200,
    key: EAuditColumnKeys.ID,
    dataIndex: EAuditColumnKeys.ID,
  },
  {
    title: <Trans i18nKey="reporting.audit.table.column.status.title" />,
    width: 200,
    key: EAuditColumnKeys.Status,
    dataIndex: EAuditColumnKeys.Status,
  },
  {
    title: <Trans i18nKey="reporting.audit.table.column.host.title" />,
    width: 200,
    key: EAuditColumnKeys.ApiHost,
    dataIndex: EAuditColumnKeys.ApiHost,
  },
  {
    title: <Trans i18nKey="reporting.audit.table.column.url.title" />,
    width: 200,
    key: EAuditColumnKeys.URL,
    dataIndex: EAuditColumnKeys.URL,
  },
  {
    title: <Trans i18nKey="reporting.audit.table.column.who.title" />,
    width: 200,
    key: EAuditColumnKeys.Who,
    dataIndex: EAuditColumnKeys.Who,
  },
  {
    title: <Trans i18nKey="reporting.audit.table.column.action.title" />,
    width: 200,
    key: EAuditColumnKeys.Action,
    dataIndex: EAuditColumnKeys.Action,
  },
  {
    title: <Trans i18nKey="reporting.audit.table.column.fields.title" />,
    width: 200,
    key: EAuditColumnKeys.Fields,
    render: (value) => <RenderDrawerComponent fields={value.fields} />,
  },
  {
    title: <Trans i18nKey="reporting.audit.table.column.when.title" />,
    width: 200,
    key: EAuditColumnKeys.Timestamp,
    render: (value) => formatDateFromISO(value.timestamp),
  },
];
